import React, { useState, useEffect } from 'react';

const SubscriptionPage = () => {
  const [userId, setUserId] = useState('');
  const [loading, setLoading] = useState(true);
  const [processingPlan, setProcessingPlan] = useState(null);

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const res = await fetch(`https://api.freebidnow.com/api/auth/me`, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Accept': 'application/json',
            'Cache-Control': 'no-cache',
          },
        });

        const data = await res.json();
        if (data._id && data.googleId) {
          setUserId(data._id);
        }
      } catch (error) {
        console.error('User lookup failed:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserInfo();
  }, []);

  const handleSubscription = async (plan) => {
    if (!userId) {
      alert('Login required before subscribing.');
      return;
    }

    setProcessingPlan(plan);

    try {
      const res = await fetch(
        `https://api.freebidnow.com/api/stripe/create-checkout-session`,
        {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ plan, userId }),
        }
      );

      const data = await res.json();

      if (data.url) {
        window.location.href = data.url;
      } else {
        console.error('❌ No Stripe URL:', data);
        alert('Error creating subscription');
        setProcessingPlan(null);
      }
    } catch (error) {
      console.error('Subscription failed:', error);
      alert('Payment failed. Try again.');
      setProcessingPlan(null);
    }
  };

  const plans = [
    { id: 'oneday', name: 'One Day', price: '$3', description: 'Access for 24 hours', btnColor: 'bg-purple-600 hover:bg-purple-700' },
    { id: 'weekly', name: 'Weekly', price: '$19.99', description: 'Access for 7 days', btnColor: 'bg-blue-600 hover:bg-blue-700' },
    { id: 'monthly', name: 'Monthly', price: '$70', description: 'Access for 30 days', btnColor: 'bg-green-600 hover:bg-green-700' },
    { id: 'sixmonths', name: '6 Months', price: '$350', description: 'Access for 180 days', btnColor: 'bg-red-600 hover:bg-red-700' },
  ];

  return (
    <div className="flex flex-col items-center min-h-screen bg-gray-100 p-6">
      <h1 className="text-3xl font-semibold mb-8">Choose Your Plan</h1>

      {loading ? (
        <p className="text-gray-500">Checking login status...</p>
      ) : !userId ? (
        <p className="text-red-600 font-medium">You must login first to subscribe.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl w-full">
          {plans.map((plan) => (
            <div key={plan.id} className="bg-white shadow-xl rounded-2xl p-6 text-center">
              <h2 className="text-xl font-bold mb-2">{plan.name} Plan</h2>
              <p className="mb-4">{plan.description}</p>
              <p className="text-2xl font-semibold mb-4">{plan.price}</p>

              <button
                onClick={() => handleSubscription(plan.id)}
                disabled={processingPlan === plan.id}
                className={`${plan.btnColor} text-white font-semibold py-2 px-4 rounded disabled:bg-gray-400`}
              >
                {processingPlan === plan.id
                  ? 'Processing...'
                  : `Subscribe ${plan.name}`}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SubscriptionPage;
